export default "__VITE_ASSET__BvrR39HI__"